import React, { useCallback, PropsWithChildren, Dispatch, SetStateAction } from 'react';
import { useState } from 'react';

export const RadioGroupContext = React.createContext<{
  selectedId: string;
  setSelectedId: Dispatch<SetStateAction<string>>;
}>(null);

interface RadioGroupProps {
  onRadioButtonSelected: (selectedId: string) => void;
  defaultSelectedId?: string;
}

function RadioGroup(props: PropsWithChildren<RadioGroupProps>) {
  const [selectedId, setSelectedId] = useState<string>(props.defaultSelectedId);

  const onClick = useCallback(
    (selectedId: string) => {
      props.onRadioButtonSelected(selectedId);
      setSelectedId(selectedId);
    },
    [props],
  );

  const value = React.useMemo(() => ({ selectedId, setSelectedId: onClick }), [selectedId, onClick]);
  return <RadioGroupContext.Provider value={value} {...props} />;
}

export { RadioGroup };
